export const convertToDecimal = (coord: string): number => {
  const dmsRegex = /^(\d{1,3})°(\d{1,2})'(\d{1,2}(\.\d+)?)$/;
  const nsewRegex = /^([0-9]+(\.[0-9]+)?)\s?[nswe]$/i;

  const match = coord.match(dmsRegex);
  if (match) {
    const degrees = parseFloat(match[1]);
    const minutes = parseFloat(match[2]);
    const seconds = parseFloat(match[3]);
    return degrees + minutes / 60 + seconds / 3600;
  }
  const matchNSEW = coord.match(nsewRegex);
  if (matchNSEW) {
    const decimalCoord = parseFloat(matchNSEW[1]);
    const direction = matchNSEW[0].toLowerCase().slice(-1);
    if (direction === "s" || direction === "w") {
      return -decimalCoord;
    }
    return decimalCoord;
  }

  return parseFloat(coord);
};
